import {
  BookmarkRounded,
  BusinessRounded,
  EventRounded,
  ExpandLess,
  ExpandMore,
  FlashOnRounded,
  ForumRounded,
  HomeRounded,
  LocalActivityRounded,
  PeopleAltRounded,
  SchoolRounded,
  ViewCarouselRounded,
  WifiTetheringRounded
} from '@mui/icons-material'
import { Collapse, Link, List, ListItem, ListItemIcon, ListItemText, styled } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router'
import { IRootState } from '../../../../../../redux/types'
import ListItemMenuButton from '../../../../styles/ListItemMenu'
import SubListItemMenu from '../../../../styles/SubListItemMenu'

const CustomSpan = styled('span')(({ theme }) => ({
  position: 'relative',
  '& div': {
    background: theme.palette.error.main,
    width: '8px',
    height: '8px',
    borderRadius: '100%',
    position: 'absolute',
    top: '-2px',
    right: '-12px'
  }
}))

function AdminMenu() {
  const { t } = useTranslation(['global'])
  const { user } = useSelector((state: IRootState) => state.auth)

  const [open, setOpen] = useState('')

  const handleClick = (id: any) => {
    if (open === id) setOpen('')
    else setOpen(id)
  }

  /* Menu */
  let menuItems: any = []
  if (user !== null) {
    if (user.role_id === 1) {
      // SUPERADMIN
      menuItems = [
        {
          id: 1,
          name: t('home'),
          icon: <HomeRounded fontSize="small" />,
          path: '/escritorio',
          list: []
        },
        {
          id: 2,
          name: t('admin.people.people'),
          icon: <PeopleAltRounded fontSize="small" />,
          path: '/admin/usuarios',
          list: []
        },
        {
          id: 3,
          name: t('slider'),
          icon: <ViewCarouselRounded fontSize="small" />,
          path: '/admin/sliders',
          list: []
        },
        {
          id: 4,
          name: t('offers'),
          icon: <LocalActivityRounded fontSize="small" />,
          path: '/admin/ofertas',
          list: []
        },
        {
          id: 5,
          name: t('updates'),
          icon: <FlashOnRounded fontSize="small" />,
          path: '/admin/novedades',
          list: []
        },
        {
          id: 6,
          name: t('news'),
          icon: <ForumRounded fontSize="small" />,
          path: '/admin/noticias',
          list: []
        },
        {
          id: 7,
          name: t('admin.library.library'),
          icon: <BookmarkRounded fontSize="small" />,
          path: '/admin/biblioteca',
          list: []
        },
        {
          id: 8,
          name: t('academy'),
          icon: <SchoolRounded fontSize="small" />,
          path: '/admin/cursos',
          list: []
        },
        {
          id: 9,
          name: 'Rutas de Formación',
          icon: <SchoolRounded fontSize="small" />,
          path: '/admin/rutas-de-formacion',
          list: []
        },
        {
          id: 10,
          name: t('events'),
          icon: <EventRounded fontSize="small" />,
          path: '/admin/events',
          list: []
        },
        {
          id: 11,
          name: t('seminars'),
          icon: <WifiTetheringRounded fontSize="small" />,
          path: '/admin/seminarios',
          list: []
        },
        {
          id: 12,
          name: t('brands'),
          icon: <BusinessRounded fontSize="small" />,
          path: '/admin/marcas',
          list: []
        }
      ]
    } else if (user.role_id === 2) {
      // ADMIN
      menuItems = [
        {
          id: 1,
          name: t('home'),
          icon: <HomeRounded fontSize="small" />,
          path: '/escritorio',
          list: []
        },
        {
          id: 2,
          name: t('admin.people.people'),
          icon: <PeopleAltRounded fontSize="small" />,
          path: '/admin/usuarios',
          list: []
        },
        {
          id: 3,
          name: t('slider'),
          icon: <ViewCarouselRounded fontSize="small" />,
          path: '/admin/sliders',
          list: []
        },
        {
          id: 4,
          name: t('offers'),
          icon: <LocalActivityRounded fontSize="small" />,
          path: '/admin/ofertas',
          list: []
        },
        {
          id: 5,
          name: t('updates'),
          icon: <FlashOnRounded fontSize="small" />,
          path: '/admin/novedades',
          list: []
        },
        {
          id: 6,
          name: t('news'),
          icon: <ForumRounded fontSize="small" />,
          path: '/admin/noticias',
          list: []
        },
        {
          id: 7,
          name: t('admin.library.library'),
          icon: <BookmarkRounded fontSize="small" />,
          path: '/admin/biblioteca',
          list: []
        },
        {
          id: 8,
          name: t('academy'),
          icon: <SchoolRounded fontSize="small" />,
          path: '/admin/cursos',
          list: []
        },
        {
          id: 9,
          name: t('events'),
          icon: <EventRounded fontSize="small" />,
          path: '/admin/events',
          list: []
        },
        {
          id: 10,
          name: t('seminars'),
          icon: <WifiTetheringRounded fontSize="small" />,
          path: '/admin/seminarios',
          list: []
        }
      ]
    } else if (user.role_id === 3) {
      // responsables
      menuItems = [
        {
          id: 1,
          name: t('home'),
          icon: <HomeRounded fontSize="small" />,
          path: '/escritorio',
          list: []
        },
        {
          id: 2,
          name: t('admin.people.people'),
          icon: <PeopleAltRounded fontSize="small" />,
          path: '/admin/usuarios',
          list: []
        }
      ]
    } else if ([8, 9].includes(user.role_id)) {
      // commercial
      menuItems = [
        {
          id: 1,
          name: t('home'),
          icon: <HomeRounded fontSize="small" />,
          path: '/escritorio',
          list: []
        },
        {
          id: 2,
          name: t('admin.people.people'),
          icon: <PeopleAltRounded fontSize="small" />,
          path: '/admin/usuarios',
          list: []
        }
      ]
    } else if (user.role_id === 5) {
      menuItems = [
        {
          id: 1,
          name: t('home'),
          icon: <HomeRounded fontSize="small" />,
          path: '/escritorio',
          list: []
        },
        {
          id: 2,
          name: t('slider'),
          icon: <ViewCarouselRounded fontSize="small" />,
          path: '/admin/sliders',
          list: []
        },
        {
          id: 3,
          name: t('offers'),
          icon: <LocalActivityRounded fontSize="small" />,
          path: '/admin/ofertas',
          list: []
        },
        {
          id: 4,
          name: t('updates'),
          icon: <FlashOnRounded fontSize="small" />,
          path: '/admin/novedades',
          list: []
        },
        {
          id: 5,
          name: t('news'),
          icon: <ForumRounded fontSize="small" />,
          path: '/admin/noticias',
          list: []
        },
        {
          id: 6,
          name: t('admin.library.library'),
          icon: <BookmarkRounded fontSize="small" />,
          path: '/admin/biblioteca',
          list: []
        },
        {
          id: 7,
          name: t('academy'),
          icon: <SchoolRounded fontSize="small" />,
          path: '/admin/cursos',
          list: []
        },
        {
          id: 8,
          name: t('events'),
          icon: <EventRounded fontSize="small" />,
          path: '/admin/events',
          list: []
        },
        {
          id: 9,
          name: t('seminars'),
          icon: <WifiTetheringRounded fontSize="small" />,
          path: '/admin/seminarios',
          list: []
        }
      ]
    }
  }

  return (
    <List sx={{ paddingTop: 3 }} component="nav">
      {menuItems.map((item: any, index: any) => (
        <div key={item.name}>
          {item.list.length > 0 ? (
            <div key={index}>
              <ListItemMenuButton onClick={() => handleClick(index)} className="admin">
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.name} />
                {open === index ? <ExpandLess color="primary" fontSize="small" /> : <ExpandMore color="primary" fontSize="small" />}
              </ListItemMenuButton>

              <Collapse in={open === index} timeout="auto" unmountOnExit>
                <SubListItemMenu disablePadding>
                  {item.list.map((list: any, indexList: number) => (
                    <Link data-testid={`menu-${item.path.replace('/', '')}`} key={indexList} component={RouterLink} to={list.path}>
                      <ListItem>
                        <ListItemText primary={list.name} />
                      </ListItem>
                    </Link>
                  ))}
                </SubListItemMenu>
              </Collapse>
            </div>
          ) : (
            <Link
              data-testid={`menu${item.path.replaceAll('/', '-')}`}
              component={RouterLink}
              to={item.path}
              key={index}
              underline={'none'}
            >
              <ListItemMenuButton selected={window.location.pathname === item.path} className="admin">
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText>
                  <CustomSpan>{item.name}</CustomSpan>
                </ListItemText>
              </ListItemMenuButton>
            </Link>
          )}
        </div>
      ))}
    </List>
  )
}

export default AdminMenu
